"use strict";
exports.__esModule = true;
exports.APP_INITIAL_STATE = void 0;
exports.APP_INITIAL_STATE = {
    wallets: [],
    walletModules: [],
    chains: []
};
